export enum EThemePreference {
  SYSTEM = "system",
  LIGHT = "light",
  DARK = "dark",
  // NOTE: NSAI-5650 — follows a fixed local-clock schedule (dark 19:00-07:00)
  // rather than the device setting, for users whose OS is not itself scheduled.
  AUTO = "auto",
}

export enum ELanguagePreference {
  EN = "en",
  AR = "ar",
  RU = "ru",
}

export enum EEmailRecapSettingPreference {
  ONLY_ME = "only_me",
  EVERYONE = "everyone",
}

export enum EAutoJoinSettingPreference {
  ALL_MEETINGS = "all_meetings",
  OWN_MEETINGS = "own_meetings",
  INVITE_IVAN = "invite_ivan",
}
